module.exports = __webpack_public_path__ + "img/img4.18e4359b.png";